import { hasExtension } from '@/app/helpers/files';

export function downloadQuadraticFile(filename: string, data: Uint8Array) {
  downloadFile(filename, data, 'application/json', 'grid');
}

export function downloadExcelFile(filename: string, data: Uint8Array) {
  downloadFile(filename, data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'xlsx');
}

export function downloadCsvFile(filename: string, data: Uint8Array) {
  downloadFile(filename, data, 'text/csv', 'csv');
}

export function downloadParquetFile(filename: string, data: Uint8Array) {
  downloadFile(filename, data, 'application/vnd.apache.parquet', 'parquet');
}

export function downloadPdfFile(filename: string, data: Uint8Array) {
  downloadFile(filename, data, 'application/pdf', 'pdf');
}

export function downloadFile(filename: string, data: Uint8Array | string, mime_type: string, extension: string) {
  const blob = new Blob([data as BlobPart], { type: mime_type });
  // A file imported from Excel keeps its name and can be renamed back to one
  // ending in .xlsx, which would otherwise export as `name.xlsx.xlsx`. Only a
  // matching extension is absorbed: exporting `data.csv` to .grid still gets
  // the .grid suffix.
  const downloadName = hasExtension(filename, extension) ? filename : `${filename}.${extension}`;
  //@ts-expect-error
  if (window.navigator.msSaveOrOpenBlob) {
    //@ts-expect-error
    window.navigator.msSaveBlob(blob, downloadName);
  } else {
    const elem = window.document.createElement('a');
    const objUrl = window.URL.createObjectURL(blob);
    elem.href = objUrl;
    elem.download = downloadName;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
    URL.revokeObjectURL(objUrl);
  }
}
